const state = {
  results: {
    data: [],
    chunked: [],
    currentIndex: 0,
  },
  catalog: {
    compuAcademicYears: [],
    meetingTypes: [],
  },
  pagination: {
    perPage: 10,
  },
};

export default state;
